module.exports = __webpack_public_path__ + "static/cer_dor_6-a3df06459765312c20ab50001ae434d4.jpg";